import React from 'react';
import { useDocumentationLogic } from './DocumentationPage.logic';
import DocumentationPageView from './DocumentationPage.view';

/**
 * Main container component for the Documentation page
 * Connects the logic and view components
 * 
 * @returns {JSX.Element}
 */
const DocumentationPage = () => {
  // Get all logic and state from the logic hook
  const documentationLogic = useDocumentationLogic();
  
  // Pass all logic and state to the view component
  return <DocumentationPageView {...documentationLogic} />;
};

export default DocumentationPage; 